import React from "react";
import "./DescriptionBox.css";
const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat
          debitis perspiciatis odio minima ullam, hic, nisi nobis veniam
          temporibus, ducimus cupiditate dolores iusto! Ex porro voluptas
          dignissimos facilis suscipit blanditiis reprehenderit tempore aperiam
          perferendis reiciendis autem illo unde, optio delectus aut voluptatum
          velit? Illum a cum ab animi odit id rem deleniti repellat distinctio
          officiis, possimus placeat eius voluptates. Deleniti illo quisquam
          doloribus quibusdam maxime beatae necessitatibus voluptatum molestiae,
          cupiditate perferendis tenetur officiis, omnis amet cum itaque eaque
          quos explicabo.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt in
          aspernatur reiciendis harum accusamus, amet veritatis rem cumque
          cupiditate sint iusto ea. Iusto, sint! Dicta sunt natus cumque labore
          cum perspiciatis odit inventore dolore voluptatibus error, quasi porro
          non praesentium?
        </p>
      </div>
    </div>
  );
};

export default DescriptionBox;
